/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink, withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import RatingStars from '../../../../../components/Rating/RatingStars/index';
import TasksUpListPopUp from '../../../../../components/Tasks/TasksUpListPopUpNew/index';
import * as formatter from '../../../../../mt-react-common/utils/formatter';
import { getValueFromRefDataModules } from '../../../../../mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';
import { getMaxDate } from '../../../../../mt-react-common/utils/otherHelpers';

class rightSidebarViewTaskAsOwner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTaskUpListPopUp: {
        isShow: false,
        selectedType: null
      },
      showTaskUpListPopUpNew: {
        isShow: false,
        selectedType: null
      }
    };
  }

  render() {
    const isCommentListGroup = this.props.location.pathname.includes(
      `${this.props.match.url}/reviews`
    );
    const isExecsListGroup = this.props.location.pathname.includes(
      `${this.props.match.url}/executions`
    );
    return (
      <React.Fragment>
        {this.state.showTaskUpListPopUpNew.isShow ? (
          <TasksUpListPopUp
            taskModel={this.props.task}
            upListFastenNow={this.props.task.upListFastenNow}
            upListMarkNow={this.props.task.upListMarkNow}
            selectedType={this.state.showTaskUpListPopUp.selectedType}
            hideTaskUpListPopUp={() => {
              this.setState({ showTaskUpListPopUpNew: false });
            }}
          />
        ) : null}
        <div className="page-sidebar-sticky">
          <div className="page-sidebar-sticky-wrp">
            <div
              aria-multiselectable="true"
              className="panel-group panel-group-side"
              id="panelGroupFilter"
              role="tablist"
            >
              <div className="panel panel-default border-b text-center">
                <div className="panel-body">
                  <div className="panel-title panel-title_xs">
                    <i aria-hidden="true" className="fa fa-check-square-o" />
                    {t('Заказчик')}
                  </div>
                  <img
                    alt=""
                    className="avatar avatar-responsive avatar_bordered"
                    src={this.props.task.ownerAvatarPath}
                  />
                  <h1 className="h5 text-overflow">
                    {this.props.task.ownerUserName}
                  </h1>
                  {this.props.task.ownerRating ? (
                    <div
                      className="label label-light label-success label_block text-overflow m-t-10"
                      data-toggle="tooltip"
                      data-container="body"
                      data-placement="top"
                      title={`Рейтинг: ${this.props.task.ownerRating.ratingStatusPoints}/${this.props.task.ownerRating.ratingStatusPointsTo} (${this.props.task.ownerRating.ratingStatusTitle})`}
                    >
                      <RatingStars
                        rating={this.props.task.ownerRating.rating}
                      />{' '}
                      {this.props.task.ownerRating.ratingStatusTitle}
                    </div>
                  ) : null}
                </div>
              </div>
              <NavLink
                to={`/my-tasks/view/${this.props.task.id}/desc`}
                activeClassName="active"
                className="list-group-item"
              >
                <span className="list-group-item-val text-overflow">
                  {t('Описание')}
                </span>
              </NavLink>
              <div className={`list-group ${isCommentListGroup ? 'in' : ''}`}>
                <NavLink
                  to={`/my-tasks/view/${this.props.task.id}/reviews`}
                  activeClassName="active"
                  className="list-group-item list-group-item-head"
                >
                  <span className="badge">
                    {this.props.task.taskCommentsStat.total}
                  </span>
                  <span className="list-group-item-val text-overflow">
                    {t('Отзывы')}
                  </span>
                </NavLink>
                <div className="list-group-menu">
                  <NavLink
                    to={`/my-tasks/view/${this.props.task.id}/reviews/likes`}
                    activeClassName="active"
                    className="list-group-item"
                  >
                    <span className="badge">
                      {this.props.task.taskCommentsStat.likes}
                    </span>
                    <span className="list-group-item-val text-overflow">
                      {t('Положительные')}
                    </span>
                  </NavLink>
                  <NavLink
                    to={`/my-tasks/view/${this.props.task.id}/reviews/dislikes`}
                    activeClassName="active"
                    className="list-group-item"
                  >
                    <span className="badge">
                      {this.props.task.taskCommentsStat.dislikes}
                    </span>
                    <span className="list-group-item-val text-overflow">
                      {t('Отрицательные')}
                    </span>
                  </NavLink>
                  <NavLink
                    to={`/my-tasks/view/${this.props.task.id}/reviews/neutral`}
                    activeClassName="active"
                    className="list-group-item"
                  >
                    <span className="badge">
                      {this.props.task.taskCommentsStat.neutral}
                    </span>
                    <span className="list-group-item-val text-overflow">
                      {t('Нейтральные')}
                    </span>
                  </NavLink>
                </div>
              </div>
              <div className={`list-group ${isExecsListGroup ? 'in' : ''}`}>
                <NavLink
                  to={`/my-tasks/view/${this.props.task.id}/executions`}
                  activeClassName="active"
                  className="list-group-item list-group-item-head"
                >
                  <span className="badge">
                    {this.props.task.tasksExecsStat.total.count}
                  </span>
                  <span className="list-group-item-val text-overflow">
                    {t('Выполнения')}
                  </span>
                </NavLink>
                <div className="list-group-menu">
                  {_.sortBy(
                    Object.values(this.props.task.tasksExecsStat.statuses),
                    [i => i.execStatusTitle]
                  ).map(item => (
                    <NavLink
                      key={`ExecStatusItem${item.execStatusId}`}
                      to={`/my-tasks/view/${this.props.task.id}/executions/${item.execStatusId}`}
                      activeClassName="active"
                      className="list-group-item"
                    >
                      <span className="badge">{item.execCountByStatus}</span>
                      <span className="list-group-item-val text-overflow">
                        {item.execStatusTitle}
                      </span>
                    </NavLink>
                  ))}
                </div>
              </div>
            </div>
            <div aria-multiselectable="true" className="" role="tablist">
              <div className="panel panel-default">
                <div className="panel-body">
                  <div className="form-group">
                    <Link to={`/my-tasks/edit/${this.props.task.id}`}>
                      <button
                        className="btn btn-primary btn-block"
                        title={t('Редактировать задание')}
                        tabIndex="0"
                      >
                        <i className="fa fa-pencil" />{' '}
                        <span className="hidden-md">
                          {t('Редактировать задание')}
                        </span>
                        <span className="hidden-lg">{t('Редактировать')}</span>
                      </button>
                    </Link>
                  </div>
                  <div className="form-group m-b-0">
                    <Link to={`/my-tasks/copy/${this.props.task.id}`}>
                      <button
                        className="btn btn-default btn-block"
                        title={t('Копировать задание')}
                        tabIndex="0"
                      >
                        <i className="fa fa-files-o" />{' '}
                        <span className="hidden-md">
                          {t('Копировать задание')}
                        </span>
                        <span className="hidden-lg">{t('Копировать')}</span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="panel panel-primary">
                <div className="panel-body">
                  <div className="font-size-h6 m-t-0 panel-title panel-title_xs text-center text-fuchsia text-strong">
                    <span role="img" aria-labelledby="rocket">
                      🚀
                    </span>{' '}
                    {t('Привлечь исполнителей')}
                  </div>
                  <hr className="m-b-15 m-t-15" />
                  {(this.props.task.upListMarkNow ||
                    this.props.task.upListFastenNow ||
                    this.props.task.upListFastenByCategoryNow ||
                    this.props.task.autoLiftInterval) && (
                    <React.Fragment>
                      <ul className="list-unstyled">
                        {this.props.task.upListMarkNow && (
                          <li className="m-b-5 text-muted">
                            <span className="text-success">
                              {t('Выделено')}
                            </span>{' '}
                            {t('до')}{' '}
                            {formatter.dateFormat5(
                              this.props.task.upListMarkNow.andTime
                            )}
                          </li>
                        )}
                        {(this.props.task.upListFastenNow ||
                          this.props.task.upListFastenByCategoryNow) && (
                          <li className="m-b-5 text-muted">
                            <span className="text-success">
                              {t('Закреплено')}
                            </span>{' '}
                            {t('до')}{' '}
                            {formatter.dateFormat5(
                              getMaxDate([
                                this.props.task.upListFastenNow &&
                                  new Date(
                                    this.props.task.upListFastenNow.andTime
                                  ),
                                this.props.task.upListFastenByCategoryNow &&
                                  new Date(
                                    this.props.task.upListFastenByCategoryNow.andTime
                                  )
                              ])
                            )}
                          </li>
                        )}
                        {this.props.task.autoLiftInterval && (
                          <li className="m-b-5 text-muted">
                            <span className="text-base text-success">
                              Автоподнятие:{' '}
                            </span>
                            {this.props.taskIntervalAutoLift.find(
                              item =>
                                item.value === this.props.task.autoLiftInterval
                            ).title ||
                              `${this.props.task.autoLiftInterval} мин.`}
                          </li>
                        )}
                      </ul>
                      <hr className="m-t-15" />
                    </React.Fragment>
                  )}
                  <div className="form-group">
                    <button
                      className="btn btn-default btn-block"
                      title={t('Закрепить задание')}
                      onClick={() => {
                        this.setState({
                          showTaskUpListPopUpNew: {
                            isShow: true,
                            selectedType: 1
                          }
                        });
                      }}
                    >
                      <i className="fa fa-thumb-tack fa-fw" />{' '}
                      {t('Закрепить задание')}
                    </button>
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-default btn-block"
                      title={t('Выделить задание')}
                      onClick={() => {
                        this.setState({
                          showTaskUpListPopUpNew: {
                            isShow: true,
                            selectedType: 2
                          }
                        });
                      }}
                    >
                      <i className="fa fa-eye fa-fw" /> {t('Выделить задание')}
                    </button>
                  </div>
                  <div className="form-group m-b-0">
                    <button
                      className="btn btn-default btn-block"
                      title={t('Поднять задание')}
                      onClick={() => {
                        this.setState({
                          showTaskUpListPopUpNew: {
                            isShow: true,
                            selectedType: 3
                          }
                        });
                      }}
                    >
                      <i className="fa fa-arrow-up" aria-hidden="true" />{' '}
                      {t('Поднять задание')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

rightSidebarViewTaskAsOwner.contextTypes = {
  router: PropTypes.shape()
};

rightSidebarViewTaskAsOwner.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    ownerUserName: PropTypes.string.isRequired,
    ownerAvatarPath: PropTypes.string.isRequired,
    ownerRating: PropTypes.shape.isRequired,
    taskCommentsStat: PropTypes.shape.isRequired,
    autoLiftInterval: PropTypes.string,
    upListFastenNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    upListFastenByCategoryNow: PropTypes.shape({
      andTime: PropTypes.string
    }),
    upListMarkNow: PropTypes.shape({
      andTime: PropTypes.string.isRequired
    }),
    tasksExecsStat: PropTypes.shape({
      statuses: PropTypes.shape({}).isRequired,
      total: PropTypes.shape({
        count: PropTypes.number
      }).isRequired
    }).isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired,
  taskIntervalAutoLift: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
  taskIntervalAutoLift: getValueFromRefDataModules(
    state,
    'tasks.taskIntervalAutoLift'
  )
});

export default connect(
  mapStateToProps,
  () => {}
)(withRouter(rightSidebarViewTaskAsOwner));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/TaskViewAsOwner/RightSidebarViewTaskAsOwner.js